import React from "react";
import { useLocation } from "react-router-dom";
import { hideDetails } from "../utilities/PageVisibiltyHandler";

export default function UserName({ user }) {
	const location = useLocation();
	// Check if current path contains "/profile/"
	const isProfilePage = hideDetails.some((path) => location.pathname.startsWith(path));

	return (
		<>
			<p>
				<i className="bi bi-person me-2"></i> <span>{user.displayName || "(Add your name)"}</span>
			</p>
			{!isProfilePage && (
				<p>
					<i className="bi bi-envelope me-2"></i> <span>{user.email || "Not set"}</span>
				</p>
			)}
		</>
	);
}
